// extracted by mini-css-extract-plugin
export default {"pagination":"InputFix_pagination__1uhFV"};